import React from 'react';
import { getExternalUrl } from '../../utils/externalUrl';
import MediaTags from './MediaTags';

const MediaHeader = ({
  mediaItem,
  editedMedia,
  editMode,
  isAdmin,
  bannerRef,
  handleInputChange,
  navigate,
  canEdit,
}) => {
  // Debug log to check canEdit value
  console.log('MediaHeader - canEdit:', canEdit);

  return (
    <header
      className="media-header"
      style={{ backgroundImage: `url(${mediaItem.horizontal_image})` }}
      ref={bannerRef}
    >
      <div>
        <div className="header-buttons left-buttons">
          <button
            className="btn"
            onClick={() => navigate(`/media-list/${mediaItem.type}/#search=${mediaItem.title}`)}
            title="View in List"
          >
            <img src="/static/icons/list-solid.svg" alt="List" className="icon" />
            <span>View in List</span>
          </button>
          <a
            href={
              mediaItem.type?.toLowerCase() === "screenmedia"
                ? getExternalUrl(mediaItem.media_format?.toLowerCase(), mediaItem.external_id)
                : getExternalUrl(mediaItem.type, mediaItem.external_id, mediaItem.source)
            }
            
            className="btn"
            target="_blank"
            rel="noopener noreferrer"
            title="View External"
          >
            <img src="/static/icons/link-solid.svg" alt="External" className="icon" />
            <span>View External</span>
          </a>
        </div>
        <div className="header-buttons right-buttons">
          {canEdit ? (
            <button
              className="favorite-btn btn"
              onClick={() => handleInputChange('is_favorite', !mediaItem.is_favorite)}
              title={mediaItem.is_favorite ? 'Remove from Favorites' : 'Add to Favorites'}
            >
              <img
                src={`/static/icons/${mediaItem.is_favorite ? 'star-solid.svg' : 'star-regular.svg'}`}
                alt="Favorite"
                className="icon"
              />
              <span>{mediaItem.is_favorite ? 'Unfavorite' : 'Favorite'}</span>
            </button>
          ) : (
            // Fallback to always show the button for debugging
            <button
              className="favorite-btn btn"
              onClick={() => console.log('Favorite button clicked - canEdit is false')}
              title="Debug: canEdit is false"
            >
              <img src="/static/icons/star-regular.svg" alt="Favorite" className="icon" />
              <span>Favorite</span>
            </button>
          )}
        </div>
      </div>
      <div className="header-overlay">
        <h1 className="media-title">
          {editMode && isAdmin ? (
            <input
              type="text"
              value={editedMedia.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
            />
          ) : (
            mediaItem.title
          )}
        </h1>
        <div className="score-display">
          <img src="/static/icons/star-solid.svg" alt="Score" className="icon" />
          {editMode && isAdmin ? (
            <input
              type="number"
              min="0"
              max="10"
              step="0.1"
              value={editedMedia.score || ''}
              onChange={(e) => handleInputChange('score', e.target.value)}
            />
          ) : (
            <span>{mediaItem.score !== null ? mediaItem.score : '--'}</span>
          )}
        </div>
        <div className='desktop-only'>
          <MediaTags media={mediaItem} mediaType={mediaItem.type} showAchievements={false} />
        </div>
      </div>
    </header>
  );
};

export default MediaHeader;